export const ERROR_REPORT_MODAL_EVENT = 'output:internal:error-report-modal';

/** Opens the error report modal. Also dispatchable by hand from the console. */
export const openErrorReportModal = () => {
  window.dispatchEvent(new CustomEvent(ERROR_REPORT_MODAL_EVENT));
};

/**
 * Client facts sent as the report's `diagnostics` blob. Everything here is read at submit
 * time so the snapshot reflects the moment the user hit send, not when the modal opened.
 */
export const collectClientDiagnostics = () => {
  const nav = typeof navigator === 'undefined' ? {} : navigator;

  return {
    // Origin + pathname only. Query strings and fragments can carry share keys or tokens,
    // and these reports are readable by staff — the route is the part with diagnostic value.
    url: `${window.location.origin}${window.location.pathname}`,
    user_agent: nav.userAgent || null,
    platform: nav.platform || null,
    language: nav.language || null,
    languages: Array.isArray(nav.languages) ? nav.languages.slice(0, 5) : null,
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    online: typeof nav.onLine === 'boolean' ? nav.onLine : null,
    hardware_concurrency: nav.hardwareConcurrency || null,
    device_memory: nav.deviceMemory || null,
    screen: typeof screen === 'undefined' ? null : `${screen.width}x${screen.height}`,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    device_pixel_ratio: window.devicePixelRatio || null,
    submitted_at: new Date().toISOString(),
  };
};
